<template>
  <div class="flex flex-col w-full">
    <div v-if="!errorPage">
      <div class="flex flex-col w-full h-auto">
        <Card class="p-5 w-full">
          <div class="flex justify-end">
            <div
              class="flex flex-grow mt-6 mb-6"
              style="justify-content: flex-end"
            >
              <Button class="bg-dynamicBackBtn text-white" @click="createTemplate()" :disabled="activeKpaTypes.length === 0">
                Create Template
              </Button>
              <Button
                background-color="none"
                class="text-dynamicBackBtn border border-solid border-dynamicBackBtn ml-4"
                @click="viewKPAModal"
              >
                Manage KPAs
              </Button>

            </div>
          </div>
          <template v-slot:footer >
            <CardFooter showmenu showyeardropdown :selected-year="selectedYear" @searchResult="handleSearch($event)" @yearSelect="handleYearSelect($event)" @reload="reload()" />
            <Menu left top="50" class="p-0 mt-6 border ml-5 shadow-lg rounded-xl w-[240px]" margin="20">
              <template v-slot:title>
                <icon
                  icon-name="more_icon"
                  size="xsm"
                  class="-mt-1"
                  style="padding: 3px 10px; width: 36px; height: 36px"
                />
              </template>
            </Menu>
          </template>
        </Card>
      </div>

      <div style="height: 100%" v-if="loading">
        <loader size="xxs" :loader-image="false" />
      </div>

      <div v-else>
        <div class="flex flex-wrap w-full my-1 text-sm">
          <div class="w-full mt-3">
            <STable
              :headers="templateBHeader"
              :items="newTemplates"
              v-if="newTemplates.length > 0"
              class="py-2 px-3 text-sm"
              style="font-size:13px;"
              :has-checkbox="false"
              :has-number="false"
              :loading="loadingTables"
            :pagination-list="metaData"
            @page="handlePage($event)"
            @itemsPerPage="handleItemsPerPage($event)"
            page-sync
            >
              <template v-slot:item="{ item }">
                <div v-if="item.agreement_description">
                    <template v-if="item.data.performance_templates && item.data.performance_templates.length > 1">
                        <Menu right top="50" class="p-0" margin="-8">
                            <template v-slot:title>
                                <div class="flex items-center cursor-pointer w-full">
                                    <icon :icon-name="getLockIconName(item.data.performance_templates[0])" size="s" class=" mr-2"/>
                                    <p class="p-2 !w-[max-content] text-sm " style="width: max-content;text-transform:capitalize;">{{item.data.year}} {{ truncateDescription(item.data.performance_templates[0].agreement_description) }}</p>
                                    <icon icon-name="chevronDown" size="xs" class="ml-auto"/>
                                </div>
                            </template>
                            <div style="width: 240px; min-height: 50px" class="py-3 px-2">
                                <div
                                    class="flex py-1 text-base"
                                    v-for="(linkedTemplate, index) in item.data.performance_templates.slice(1)"
                                    :key="index"
                                >
                                  <Menu @click.stop right top="50" class="p-0" margin="30" style="width: 100%;">
                                    <template v-slot:title>
                                      <div class="flex items-center cursor-pointer w-full gap-[5px]">
                                        <icon :icon-name="getLockIconName(linkedTemplate)" size="s" class=" mr-2"/>
                                        <p class="text-sm " style="text-transform:capitalize;font-weight:600;">{{item.data.year}} {{ truncateDescription(linkedTemplate.agreement_description) }} {{ getAlphabetForLinkedTemplate(linkedTemplate.linkNo) }}</p>
                                        <icon
                                        icon-name="more_icon"
                                        size="xsm"
                                        class="-mt-1 ml-auto"
                                      />
                                      </div>
                                    </template>
                                    <div style="width: 200px; min-height: 50px" class="py-3 px-2">
                                      <div class="flex py-2 px-3 cursor-pointer" v-if="!item.data.isLocked" @click="editLinkedTemplate(linkedTemplate.id)">
                                        <icon icon-name="edit" class-name="text-blueCrayola mr-2" size="xs" />
                                        <p class="pt-1" style="font-size: 14px">Edit Template</p>
                                      </div>
                                      <div class="flex py-2 px-3 cursor-pointer" v-if="!item.data.isLocked" @click="initiateDelete(linkedTemplate.id)">
                                        <icon icon-name="delete" class-name="text-flame mr-2" size="xs" />
                                        <p class="pt-1" style="font-size: 14px">Delete Template</p>
                                      </div>
                                      <div class="flex py-2 px-3 cursor-pointer" v-if="item.data.isLocked" @click="viewTemplate(linkedTemplate.id)">
                                        <icon icon-name="icon-eye" class-name="text-darkPurple mr-2" size="xs" />
                                        <p class="" style="font-size: 14px">View Template</p>
                                      </div>
                                    </div>
                                  </Menu>
                                </div>
                            </div>
                        </Menu>
                    </template>
                    <template v-else>
                        <div class="flex items-center text-sm">
                            <icon :icon-name="getLockIconName(item.data)" size="s" class="mr-2"/>
                            <p class="p-2 !w-[max-content] " style="text-transform:capitalize;"> {{item.data.year}} {{ truncateDescription(item.data.performance_templates[0].agreement_description) }} </p>
                        </div>
                    </template>
                </div>

                <!-- Contract Period Column -->
                <div v-if="item.contract_period">
                    <span class="text-sm" >
                        {{ formatDateRange(item.data.performance_templates[0].appraisal_cycle.cycle_start_date, item.data.performance_templates[0].appraisal_cycle.cycle_end_date) }}
                    </span>
                </div>

                <!-- Agreement Period Column -->
                <div v-if="item.agreement_period">
                  <span class="text-sm" >
                    {{ formatDateRange(item.data.performance_templates[0].appraisal_cycle.agreement_start, item.data.performance_templates[0].appraisal_cycle.agreement_end) }}
                    </span>
                </div>

                <!-- Appraisal Column -->
                <div v-if="item.appraisal_frequency">
                    <span class="capitalize text-sm">
                        {{item.data.type}}
                    </span>
                </div>

                <!-- KPAs Column -->
                <div v-if="item.kpa_types">
                    <div class="w-auto" >
                            <span class="text-sm"> Standard ({{item.data.kpaTypesCount}})</span>
                    </div>
                </div>

                <!-- Status Column -->
                <div v-if="item.status" class="flex flex-wrap">
                  <div class="flex w-auto">
                    <div
                      class="mb-2 capitalize"
                      style="width: 120px; height: 28px; padding: 5px 0px"
                    >
                      <Badge
                        :label="item.data.status"
                        v-if="item.data.status === 'open' || item.data.status === 'active'"
                        variant="primary"
                        style="width:120px;padding:8px;text-align:center;border-radius:8px;"
                        background-color="rgba(19, 181, 106, 0.15)"
                        color="#13B56A"
                      />
                      <Badge
                        :label="item.data.status"
                        v-if="item.data.status === 'pending closeout'"
                        variant="primary"
                        style="width:120px;padding-top:8px; padding-bottom:8px;padding-left: 13px;padding-right:13px;border-radius:8px;"
                        background-color="rgba(233, 147, 35, 0.15)"
                        color="#E99323"
                      />
                      <Badge
                        :label="item.data.status"
                        v-if="item.data.status === 'closed'"
                        variant="primary"
                        style="width:120px;padding:8px;text-align:center;border-radius:8px;"
                        background-color="rgba(135, 142, 153, 0.15)"
                        color="#878E99"
                      />
                       <Badge
                        :label="item.data.status"
                        v-if="item.data.status === 'draft'"
                        variant="primary"
                        style="width:120px;padding:8px;text-align:center;border-radius:8px;"
                        background-color="rgba(135, 142, 153, 0.15)"
                        color="#878E99"
                      />
                    </div>
                  </div>
                </div>
                <!-- Actions Column -->
                <div v-if="item.id" class="flex">
                  <Menu left top="50" class="p-0" margin="10">
                    <template v-slot:title>
                      <icon
                        icon-name="more_icon"
                        size="xsm"
                        class="-mt-1"
                        style="padding: 3px 10px; width: 36px; height: 36px"
                      />
                    </template>
                    <div style="width: 220px; height: max-content" class="py-3 px-2">
                      <template v-if="item.data.isLocked">
                        <div class="flex py-1 px-3 cursor-pointer" @click="viewTemplate(item.data.performance_templates[0].id)">
                          <icon icon-name="icon-eye" class-name="text-darkPurple mr-2" size="xs" />
                          <p class="" style="font-size: 14px">View Template</p>
                        </div>

                      </template>
                      <!-- Options for other statuses -->
                      <template v-else>
                        <div class="flex py-2 px-3 cursor-pointer" @click="editTemplate(item.data.performance_templates[0].id)">
                          <icon icon-name="edit" class-name="text-blueCrayola mr-2" size="xs" />
                          <p class="" style="font-size: 14px">Edit Template</p>
                        </div>
                        <div class="flex py-2 px-3 cursor-pointer" @click="viewTemplate(item.data.performance_templates[0].id)">
                          <icon icon-name="icon-eye" class-name="text-darkPurple mr-2" size="xs" />
                          <p class="" style="font-size: 14px">View Template</p>
                        </div>
                        <div v-if="item.data.performance_templates[0].status !== 'draft'" class="flex py-2 px-3 cursor-pointer" @click="createLinkedTemplate(item.data)">
                          <icon icon-name="create" fill="transparent" class="fill-transparent mr-2" size="xs" />
                          <p class="" style="font-size: 14px">Create a Linked Template</p>
                        </div>
                        <div class="flex py-2 px-3 cursor-pointer" @click="copyTemplate(item.data.id)">
                          <icon icon-name="copy" fill="transparent"  class=" mr-2" size="xs" />
                          <p class="" style="font-size: 14px">Copy Template</p>
                        </div>
                        <div class="flex px-2 py-1 more h-8 cursor-pointer" @click="initiateDelete(item.data.performance_templates[0].id)">
                          <icon icon-name="delete" class-name="text-desire mr-2" size="xs" />
                          <p class="" style="font-size: 14px">Delete Template</p>
                        </div>
                      </template>
                    </div>
                  </Menu>
                </div>
              </template>
            </STable>

            <div class="flex flex-wrap w-full my-1 p-5 justify-center" v-else>
              <div class="my-4 w-full flex py-6 justify-center">
                <img src="@/assets/images/empty_template.png" alt="" />
              </div>
              <div class="w-3/5 flex justify-center">
                <p class="text-base mt-5 text-center">
                  You have not setup a performance template. You need to create
                  one with the button below, setting up the name and attaching
                  the template to as many KPA types you wish to.
                </p>
              </div>

              <div
                class="text-flame font-semibold flex w-full justify-center my-4 p-2 text-base cursor-pointer"
                @click="createTemplate()"
              >
                <icon icon-name="icon-plus" class="mr-2" size="xsm" />
                New Template
              </div>
            </div>
          </div>
        </div>
      </div>

      <ValidationObserver v-slot="{ handleSubmit }">
        <RightSideBar
          v-if="kpaModal"
          @close="closeKPAModal"
          submit='Save'
          @submit="saveToggleStatus"
          button-class="bg-dynamicBackBtn text-white"
        >
          <template v-slot:title>
            <p class="text-darkPurple">Manage KPAs</p>
          </template>
          <template v-slot:subtitle>
            <p class="font-semibold text-darkPurple my-4 text-base">
              Add KPA types used in your templates here. Note that you will not
              be able to remove a KPA type, once it has been applied in a
              template.
            </p>
          </template>

          <div class="flex flex-col font-semibold my-4 text-base">
            KPA Types
          </div>
          <div v-if="kpaTypes && kpaTypes.length > 0" class="overflow-y-auto" style="height:69vh;">
            <div
            v-for="(kpa, index) in kpaTypes.filter(k => !k.hasDefaultKPI)"
            :key="kpa.id || `kpa-${index}`"
              class="flex items-center w-full my-2 flex-1"
            >
              <label class="switch mr-3">
                <input
                  type="checkbox"
                  v-model="kpa.tempStatus"
                  :checked="kpa.tempStatus"
                  :disabled="kpa.isCustom && !kpa.saved"
                />
                <span class="slider round" :class="{ 'opacity-50 cursor-not-allowed': kpa.isCustom && !kpa.saved }"></span>
              </label>

              <!-- KPA Name -->
              <div class="flex-1">
                <c-text
                  v-model="kpa.editedName"
                  :placeholder="'Enter KPA Type'"
                  class="w-full"
                  type="text"
                  :disabled="!kpa.isEditing"
                  :value="!kpa.isEditing ? kpa.name : kpa.editedName"
                />
              </div>

              <!-- Edit/Save Icons -->
              <div class="flex items-center">
                <div
                v-if="!kpa.isEditing"
                class="cursor-pointer flex"
                @click="startEditing(kpa)"
                >
                <icon
                  v-if="!kpa.isEditing"
                  icon-name="icon-edit"
                  size="xms"
                  class="mx-3 text-blueCrayola cursor-pointer"
                  @click="startEditing(kpa)"
                />
                </div>
                <div
                v-else
                class="cursor-pointer flex"
                @click="saveKPA(kpa)"
                >
                <icon
                  icon-name="save"
                  size="xms"
                  class="mx-3 text-blueCrayola cursor-pointer"
                />
                </div>
                <div v-if="kpa.isEditing" @click.stop="cancelEditing(kpa)">
                <icon
                  v-if="kpa.isEditing"
                  icon-name="close-icon"
                  size="xs"
                  class="mx-3 cursor-pointer text-flame"
                  @click.stop="cancelEditing(kpa)"
                />
                </div>
              </div>
            </div>

            <!-- Core Values Group -->
            <div
              v-for="(kpa) in kpaTypes.filter(k => k.kpas?.length > 0 && k.hasDefaultKPI) "
              :key="kpa.id"
              class="border rounded-lg p-4 my-4 bg-white"
            >
              <!-- Core Values Header -->
              <div class="flex items-center w-full mb-4">
                <label class="switch mr-3">
                  <input
                    type="checkbox"
                    v-model="kpa.tempStatus"
                    :checked="kpa.tempStatus"
                    :disabled="kpa.isCustom && !kpa.saved"
                  />
                  <span class="slider round" :class="{ 'opacity-50 cursor-not-allowed': kpa.isCustom && !kpa.saved }"></span>
                </label>

                <div class="flex-1">
                  <c-text
                    v-if="!kpa.isEditing"
                    :value="kpa.name"
                    disabled
                    class="w-full font-semibold"
                  />
                  <c-text
                    v-else
                    v-model="kpa.editedName"
                    :placeholder="'Enter KPA Type'"
                    class="w-full font-semibold"
                  />
                </div>

                <div class="flex items-center">
                  <div
                  v-if="!kpa.isEditing"
                  class="cursor-pointer flex"
                  @click="startEditing(kpa)"
                  >
                  <icon
                    icon-name="icon-edit"
                    size="xms"
                    class="mx-3 text-blueCrayola cursor-pointer"
                  />
                  </div>
                  <div
                  v-else
                  class="cursor-pointer flex"
                  @click="saveKPA(kpa)"
                  >
                  <icon
                    icon-name="save"
                    size="xms"
                    class="mx-3 text-blueCrayola cursor-pointer"
                  />
                  </div>
                  <div v-if="kpa.isEditing" @click.stop="cancelEditing(kpa)">
                    <icon
                      icon-name="close-icon"
                      size="xs"
                      class="mx-3 cursor-pointer text-flame"
                    />
                  </div>
                </div>
              </div>

              <hr/>

              <!-- Sub KPAs -->
              <div
                v-for="(subKpa, subIndex) in kpa.kpas"
                :key="subKpa.id || `subkpa-${subIndex}`"
                class="flex items-center w-full my-2"
              >
                <!-- Checkbox for sub KPAs -->
                <label class="checkbox-container mr-3">
                  <input
                    type="checkbox"
                    v-model="subKpa.tempStatus"
                    :checked="subKpa.tempStatus"
                    :disabled="subKpa.isCustom && !subKpa.saved"
                  />
                  <span class="checkmark" :class="{ 'opacity-50 cursor-not-allowed': subKpa.isCustom && !subKpa.saved }"></span>
                </label>

                <div class="flex-1">
                  <c-text
                    v-if="!subKpa.isEditing"
                    :value="subKpa.name"
                    disabled
                    class="w-full"
                  />
                  <c-text
                    v-else
                    v-model="subKpa.editedName"
                    :placeholder="'Enter Sub KPA'"
                    class="w-full"
                  />
                </div>

                <div class="flex items-center">
                  <div
                  v-if="!subKpa.isEditing"
                  class="cursor-pointer flex"
                  @click="startEditing(subKpa)"
                  >
                  <icon
                    icon-name="icon-edit"
                    size="xms"
                    class="mx-3 text-blueCrayola cursor-pointer"
                  />
                  </div>
                  <div
                  v-else
                  class="cursor-pointer flex"
                  @click="saveSubKpa(subKpa)"
                  >
                  <icon
                    icon-name="save"
                    size="xms"
                    class="mx-3 text-blueCrayola cursor-pointer"
                  />
                  </div>
                  <div v-if="subKpa.isEditing" @click.stop="cancelEditing(subKpa)">
                  <icon
                    v-if="subKpa.isEditing"
                      icon-name="close-icon"
                      size="xs"
                      class="mx-3 cursor-pointer text-flame"
                    />
                  </div>
                  <!-- <div
                    v-else-if="!subKpa.isDefault && subKpa.saved"
                  class="cursor-pointer flex"
                  @click="handleSubKpaDelete(subKpa, subIndex)"
                  >
                  <icon
                    icon-name="icon-trash"
                    size="xs"
                    class="mx-3 cursor-pointer"
                  />
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </RightSideBar>
      </ValidationObserver>

      <Modal v-if="dialogDel">
        <Card class="p-5 flex flex-col max-w-md">
          <div class>
            <p class="font-bold ml-4 my-5 text-center">
              Are you sure you want to delete this Template?
            </p>
            <div class="flex">
              <Button class="bg-dynamicBackBtn text-white" @click="deleteTemplate">
                Yes
              </Button>
              <Button
                background-color="none"
                class="text-dynamicBackBtn border border-solid border-dynamicBackBtn ml-4"
                @click="dialogDel = false"
              >
                Cancel
              </Button>
            </div>
          </div>
        </Card>
      </Modal>
    </div>

    <div v-else>
      <ErrorPage />
    </div>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import STable from "@scelloo/cloudenly-ui/src/components/table";
import Badge from "@scelloo/cloudenly-ui/src/components/badge";
import CText from "@scelloo/cloudenly-ui/src/components/text";
import Button from "@/components/Button";
import Card from "@/components/Card";
import CardFooter from "@/components/CardFooter";
import RightSideBar from "@/components/RightSideBar";
import Icon from "@/components/Icon";
import Menu from "@/components/Menu";
import Modal from "@/components/Modal";
import ErrorPage from "@/modules/Admin/error403";

export default {
  name: "PerformanceTemplate",
  components: {
    ValidationObserver,
    Button,
    Badge,
    RightSideBar,
    ErrorPage,
    CText,
    STable,
    Card,
    CardFooter,
    Icon,
    Modal,
    Menu,
  },
  data() {
    return {
      category: [
        {
          name: "Allow functional managers to edit templates",
          radioName: "employee",
          value: "",
        },
        {
          name: "Allow functional managers to adjust weight",
          radioName: "employee",
          value: "",
        },
        { name: "Both", radioName: "employee", value: "" },
      ],
      dialogDel: false,
      loading: true,
      templateModal: false,
      kpaModal: false,
      errorPage: false,
      loadingTables: true,
      templateBHeader: [
        { title: "Description", value: "agreement_description" },
        { title: "Contract Period", value: "contract_period" },
        { title: "Agreement Period", value: "agreement_period" },
        { title: "Appraisal", value: "appraisal_frequency" },
        { title: "KPAs", value: "kpa_types" },
        { title: "Status", value: "status" },
        { title: "", value: "id", image: true },
      ],
      activeKpaTypes: [],
      importTemplate: false,
      prevTemplate: false,
      templateTitle: "",
      templates: [],
      newTemplates: [],
      optionsKPA: [],
      kpaTypes: [],
      locations: [],
      jobLevels: [],
      functions: [],
      designations: [],
      deleteId: "",
      docCycle: "doc-cycle",
      moreIcon: "more_icon",
      disableSave: true,
      searchQuery: '',
      metaData: {},
      itemsPerPage: null,
      numberOfPage: null,
      selectedYear: 'All',
      tableColumns: [
        { label: 'Description', visible: true, disabled: false },
        { label: 'Contracting Period', visible: true, disabled: false },
        { label: 'Performance Period', visible: true, disabled: false },
        { label: '1st Appraisal', visible: true, disabled: false },
        { label: 'Final Appraisal', visible: true, disabled: false },
        { label: 'KPAs', visible: true, disabled: false },
        { label: 'Status', visible: true, disabled: false },
        { label: 'Applies To', visible: false, disabled: true },
      ],
    };
  },
  methods: {
    handleItemsPerPage(itemNo) {
      this.itemsPerPage = itemNo;
      this.queryUpdate();
    },

    handlePage(pageNumber) {
      this.numberOfPage = pageNumber;
      this.queryUpdate();
    },

    queryUpdate() {
      this.loadingTables = true;
      const search = this.searchQuery ? `&search=${this.searchQuery}` : "";
      const pageNumber = this.numberOfPage
        ? `&page=${this.numberOfPage}`
        : `&page=${this.metaData.page}`;
      const itemPage = this.itemsPerPage ? `&perPage=${this.itemsPerPage}` : "";
      this.getTemplates(`?${pageNumber}${itemPage}${search}`);
    },

    handleSearch(value) {
      this.searchQuery = `?search=${value}`;
      this.selectedYear = '';
      this.loadingTables = true;
      this.getTemplates(this.searchQuery);
    },

    handleYearSelect(year) {
      const yearQuery = year === 'All' ? '' : `?year=${year}`;
      this.searchQuery = yearQuery;
      this.selectedYear = year;
      this.loadingTables = true;
      this.getTemplates(yearQuery);
    },

    async handleKpaDelete(k, index) {
      try {
        await this.$handlePrivilege("performance", "deleteKpaTypes");
        this.deleteKPA(k, index);
      } catch (error) {
        this.$toasted.error("You do not have permission to perform this task", {
          duration: 5000,
        });
      }
    },

    async handleEditKPA(k) {
      try {
        await this.$handlePrivilege("performance", "editKpaTypes");
        this.openEdit(k);
      } catch (error) {
        this.$toasted.error("You do not have permission to perform this task", {
          duration: 5000,
        });
      }
    },

    async handleCreateKPA() {
      try {
        await this.$handlePrivilege("performance", "addNewKpaType");
        this.createKPA();
      } catch (error) {
        this.$toasted.error("You do not have permission to perform this task", {
          duration: 5000,
        });
      }
    },

    async viewKPAModal() {
      try {
        await this.$handlePrivilege("performance", "manageKPAS");
        this.kpaModal = true;
      } catch (error) {
        this.$toasted.error("You do not have permission to perform this task", {
          duration: 5000,
        });
      }
    },

    async createTemplate() {
      try {
        await this.$handlePrivilege(
          "performance",
          "createTemplate"
        );
        this.$router.push({
          name: "TemplateSettings",
          params: { id: "new" },
        });
      } catch (error) {
        this.$toasted.error("You do not have permission to perform this task", {
          duration: 5000,
        });
      }
    },

    async viewTemplate(item) {
      try {
        await this.$handlePrivilege("performance", "viewTemplateUsage");
        this.$router.push({
          name: "ViewTemplateSettings",
          params: { id: item },
          query: { mode: 'view' }

        });
      } catch (error) {
        this.$toasted.error("You do not have permission to perform this task", {
          duration: 5000,
        });
      }
    },
    async editTemplate(item) {
      try {
        await this.$handlePrivilege("performance", "editTemplate");
        this.$router.push({
          name: "EditSettings",
          params: { id: item },
          query: { mode: 'edit' }
        });
      } catch (error) {
        this.$toasted.error("You do not have permission to perform this task", {
          duration: 5000,
        });
      }
    },
    async editLinkedTemplate(item) {
      try {
        await this.$handlePrivilege("performance", "editTemplateUsage");
        this.$router.push({
          name: "EditLinkedTemplate",
          params: { id: item },
          query: { mode: 'edit' }
        });
      } catch (error) {
        this.$toasted.error("You do not have permission to perform this task", {
          duration: 5000,
        });
      }
    },

    initiateDelete(id) {
      this.dialogDel = true;
      this.deleteId = id;
    },

    deleteTemplate() {
      this.$_deletePerfomanceTemplate(this.deleteId)
        .then((response) => {
          this.$toasted.success(response.data.message, { duration: 5000 });
          this.dialogDel = false;
          this.loading = true;
          this.loadingTables = true;
          this.getTemplates('');
        })
        .catch((err) => {
          this.$toasted.error(err.response.data.message, { duration: 5000 });
        });
    },

    copyTemplate(linkId) {
      this.$_copyPerfomanceTemplate(linkId)
        .then((response) => {
          this.$toasted.success(response.data.message, { duration: 5000 });
          // this.dialogDel = false;
          this.loading = true;
          this.getTemplates('');
        })
        .catch((err) => {
          this.$toasted.error(err.response.data.message, { duration: 5000 });
        });
    },

    normalizeKPA(kpaTypes) {
      const normalizedKPAs = kpaTypes.map(kpa => ({
        ...kpa,
        saved: true,
        isEditing: false,
        editedName: kpa.name,
        tempStatus: kpa.status === 'active',
        status: kpa.status || 'inactive',
        hasDefaultKPI: kpa.hasDefaultKPI,
        isCustom: false
      }));

      const processedKPAs = normalizedKPAs.map(kpa => {
        if (kpa.hasDefaultKPI && kpa.kpas) {
          return {
            ...kpa,
            kpas: kpa.kpas.map(subKpa => ({
              ...subKpa,
              saved: true,
              isEditing: false,
              editedName: subKpa.name,
              tempStatus: subKpa.status === 'active',
              status: subKpa.status || 'inactive',
              hasDefaultKPI: subKpa.hasDefaultKPI,
              isCustom: false
            }))
          };
        }
        return kpa;
      });

      // Count saved custom KPAs (isDefault: false) from API response
      const savedCustomKPAsCount = processedKPAs
        .filter(k => k.isDefault === false && !k.hasDefaultKPI)
        .length;

      // Preserve existing custom KPAs that haven't been saved
      const existingCustomKPAs = this.kpaTypes
        ? this.kpaTypes.filter(k => k.isCustom && !k.saved && !k.hasDefaultKPI)
        : [];

      // Calculate how many custom KPAs we need: 4 - (saved custom count + unsaved custom count)
      const totalCustomKPAs = savedCustomKPAsCount + existingCustomKPAs.length;
      const neededCustomKPAs = Math.max(0, 4 - totalCustomKPAs);
      const newCustomKPAs = neededCustomKPAs > 0 ? Array.from({ length: neededCustomKPAs }, (_, index) => ({
        id: `custom-kpa-${Date.now()}-${index}`,
        name: 'Custom',
        orgId: this.$orgId,
        saved: false,
        isEditing: false,
        editedName: 'Custom',
        tempStatus: false,
        status: 'inactive',
        hasDefaultKPI: false,
        isCustom: true,
        isDefault: false
      })) : [];

      const coreValues = processedKPAs.find(k => k.hasDefaultKPI);
      if (coreValues && coreValues.kpas) {
        const savedCustomSubKPAsCount = coreValues.kpas
          .filter(k => k.isDefault === false)
          .length;

        const existingCoreValues = this.kpaTypes
          ? this.kpaTypes.find(k => k.hasDefaultKPI)
          : null;
        const existingCustomSubKPAs = existingCoreValues && existingCoreValues.kpas
          ? existingCoreValues.kpas.filter(k => k.isCustom && !k.saved)
          : [];

        const totalCustomSubKPAs = savedCustomSubKPAsCount + existingCustomSubKPAs.length;
        const neededCustomSubKPAs = Math.max(0, 2 - totalCustomSubKPAs);
        if (neededCustomSubKPAs > 0) {
          const newCustomSubKPAs = Array.from({ length: neededCustomSubKPAs }, (_, index) => ({
            id: `custom-subkpa-${Date.now()}-${index}`,
            name: 'Custom',
            kpaTypeId: coreValues.id,
            orgId: this.$orgId,
            saved: false,
            isEditing: false,
            editedName: 'Custom',
            tempStatus: false,
            status: 'inactive',
            hasDefaultKPI: false,
            isCustom: true,
            isDefault: false
          }));
          coreValues.kpas = [...coreValues.kpas, ...existingCustomSubKPAs, ...newCustomSubKPAs];
        } else {
          coreValues.kpas = [...coreValues.kpas, ...existingCustomSubKPAs];
        }
      }

      this.kpaTypes = [...processedKPAs, ...existingCustomKPAs, ...newCustomKPAs];
      this.optionsKPA = kpaTypes.map(({ id, name }) => ({ id, name }));
    },

    startEditing(kpa) {
      // Store the original name before editing
      const originalName = kpa.name || kpa.editedName || '';
      const updatedKpa = { ...kpa, isEditing: true, editedName: originalName, originalName };
          if (kpa.kpaTypeId) {
        const parentKpa = this.kpaTypes.find(k => k.id === kpa.kpaTypeId);
        if (parentKpa && parentKpa.kpas) {
          const subIndex = parentKpa.kpas.findIndex(sub => sub.id === kpa.id);
          if (subIndex !== -1) {
            this.$set(parentKpa.kpas, subIndex, updatedKpa);
          }
        }
      } else {
        const index = this.kpaTypes.findIndex(k => k.id === kpa.id);
        if (index !== -1) {
          this.$set(this.kpaTypes, index, updatedKpa);
        }
      }
    },

    cancelEditing(kpa) {
      const originalName = kpa.originalName !== undefined ? kpa.originalName : (kpa.name || '');
      const updatedKpa = {
        ...kpa,
        isEditing: false,
        editedName: originalName,
        name: originalName
      };
      delete updatedKpa.originalName;

      if (kpa.kpaTypeId) {
        const parentKpa = this.kpaTypes.find(k => k.id === kpa.kpaTypeId);
        if (parentKpa && parentKpa.kpas) {
          let subIndex = parentKpa.kpas.findIndex(sub => sub.id === kpa.id);
          if (subIndex === -1) {
            subIndex = parentKpa.kpas.findIndex(sub => sub === kpa);
          }
          if (subIndex !== -1) {
            this.$set(parentKpa.kpas, subIndex, updatedKpa);
          }
        }
      } else {
        let index = this.kpaTypes.findIndex(k => k.id === kpa.id);
        if (index === -1) {
          index = this.kpaTypes.findIndex(k => k === kpa);
        }
        if (index !== -1) {
          this.$set(this.kpaTypes, index, updatedKpa);
        }
      }
    },

    async saveKPA(kpa) {
      try {
        if (!kpa.editedName || kpa.editedName.trim() === '') {
          this.$toasted.error('KPA Type name cannot be empty', { duration: 5000 });
          return;
        }
                if (!Number.isNaN(kpa.editedName) && !Number.isNaN(parseFloat(kpa.editedName))) {
          this.$toasted.error('KPA Type cannot be a number. Please enter text only.', { duration: 5000 });
          return;
        }
        const payload = {
          orgId: kpa.orgId || this.$orgId,
          name: kpa.editedName,
        };

        let response;
        if (kpa.id && !kpa.id.toString().startsWith('custom-') && kpa.editedName !== '' && typeof kpa.editedName !== 'number') {
          payload.id = kpa.id;
          payload.request = { name: kpa.editedName };
          response = await this.$_editKPAtypes(payload);
        } else {
          payload.request = {
            name: kpa.editedName,
            orgId: kpa.orgId || this.$orgId,
            kpaTypeId: kpa.kpatypeId,
            objective: 'Custom Objective',
            weight: 0,
          };
          response = await this.$_createKPAtypes(payload);
        }

        this.$toasted.success('KPA saved successfully', { duration: 5000 });
        const index = this.kpaTypes.findIndex(k => k.id === kpa.id);
        if (index !== -1) {
          const updatedKpa = {
            ...kpa,
            name: kpa.editedName,
            isEditing: false,
            saved: true,
            isCustom: false
          };

          if (kpa.id && kpa.id.toString().startsWith('custom-') && response?.data?.data?.id) {
            updatedKpa.id = response.data.data.id;
          }

          this.$set(this.kpaTypes, index, updatedKpa);
        }

        await this.getKPATypes();
      } catch (error) {
        this.$toasted.error(error.response?.data?.message || 'Error saving KPA', { duration: 5000 });
      }
    },

    deleteKPA(kpa, index) {
      if (kpa.isCustom && !kpa.saved) {
        this.kpaTypes.splice(index, 1);
        return;
      }
      if (kpa.id && !kpa.id.toString().startsWith('custom-')) {
        this.$_deleteKPAtypes(kpa.id).then((response) => {
          this.$toasted.success(response.data.message, { duration: 5000 });
        });
      }
      this.kpaTypes.splice(index, 1);
    },

    closeKPAModal() {
      this.kpaModal = false;
      this.getKPATypes();
    },

    getKPATypes() {
      this.$_getKPAtypes().then((response) => {
        const kpaTypes = response.data.KpaType;
        this.normalizeKPA(kpaTypes);
      });

      this.$_getActiveKPAtypes().then((response) => {
        this.activeKpaTypes = response.data.KpaType;
      });
    },

    getLocation(id) {
      let name = "";
      this.locations.filter((location) => {
        if (location.id === id) {
          name = location.name;
        }
        return {};
      });
      return name;
    },

    getLevels(id) {
      let name = "";
      this.jobLevels.filter((levels) => {
        if (levels.id === id) {
          name = levels.name;
        }
        return {};
      });
      return name;
    },

    getFunctionName(id) {
      let name = "";
      this.functions.filter((func) => {
        if (func.id === id) {
          name = func.name;
        }
        return {};
      });
      return name;
    },

    getDesignationName(id) {
      let name = "";
      this.designations.filter((designation) => {
        if (designation.id === id) {
          name = designation.name;
        }
        return {};
      });
      return name;
    },

    getLocations() {
      this.$_getHumanarLocations("").then((response) => {
        this.locations = [];
        response.data.outlets.forEach((outlet) => {
          this.locations.push({
            id: outlet.id,
            name: outlet.name,
          });
        });
      });
    },

    getJobLevels() {
      this.$_getLevels().then((response) => {
        response.data.levels.forEach((level) => {
          this.jobLevels.push({
            id: level.id,
            name: level.name,
          });
        });
      });
    },

    getFunctions() {
      this.$_getFunctionKpis("").then((response) => {
        response.data.functions.forEach((f) => {
          this.functions.push({
            id: f.id,
            name: f.name,
          });
        });
      });
    },

    getDesignations() {
      this.$_getDesignations("").then((response) => {
        response.data.designations.forEach((designation) => {
          this.designations.push({
            id: designation.id,
            name: designation.name,
          });
          return {};
        });
      });
    },

    getTemplates(params) {
      let templatesArr = [];
      this.templates = [];
      this.newTemplates = [];
      this.$_getLinkedPerfomanceTemplate(params).then((response) => {
        templatesArr = response.data.PerformanceTemplate;
        this.metaData = response.data.meta;
        this.loading = false;
        this.loadingTables = false;
        templatesArr.forEach((template) => {
          this.newTemplates.push({
            kpaTypesCount : template.kpaTypesCount,
            performance_templates : template.performance_templates,
            status : template.status,
            type: template.type,
            isLocked: template.isLocked,
            year: template.year,
            agreement_description: template.performance_templates[0].agreement_description,
            contract_period: template.performance_templates[0].cycle_start_date || '-',
            agreement_period: template.performance_templates[0].cycle_end_date || '-',
            kpa_types: template.kpaTypesCount,
            appraisal_frequency: template.type,
            id: template.id,
          });
        });
        this.loadingTables = false;
      });
    },

    async reload() {
      this.loadingTables = true;
      await this.getTemplates('');
    },

    async handleSubKpaDelete(subKpa, subIndex) {
      try {
        // If it's a custom sub-KPA that hasn't been saved, just remove it from the array
        if (subKpa.isCustom && !subKpa.saved) {
          const parentKpa = this.kpaTypes.find(k => k.hasDefaultKPI);
          if (parentKpa) {
            parentKpa.kpas.splice(subIndex, 1);
          }
          return;
        }
        // Otherwise, delete via API
        if (subKpa.id && !subKpa.id.toString().startsWith('custom-')) {
          await this.$_deleteKPAobjective(subKpa.id);
          this.$toasted.success('Sub KPA deleted successfully', { duration: 5000 });
        }
        const parentKpa = this.kpaTypes.find(k => k.name === 'Core Values');
        if (parentKpa) {
          parentKpa.kpas.splice(subIndex, 1);
        }
      } catch (error) {
        this.$toasted.error(error.response?.data?.message || 'Error deleting Sub KPA', { duration: 5000 });
      }
    },

    async saveSubKpa(subKpa) {
      try {
        if (!subKpa.editedName || subKpa.editedName.trim() === '') {
          this.$toasted.error('Core Value name cannot be empty', { duration: 5000 });
          return;
        }

        const coreValues = this.kpaTypes.find(k => k.name === 'Core Values');
        if (!coreValues) {
          this.$toasted.error('Core Values not found', { duration: 5000 });
          return;
        }

        let payload;
        let response;
        if (subKpa.id && !subKpa.id.toString().startsWith('custom-')) {
          // Editing existing core value
          payload = {
            id: subKpa.id,
            orgId: subKpa.orgId || this.$orgId,
            request: {
              name: subKpa.editedName
            }
          };
          response = await this.$_editKPAobjective(payload);
        } else {
          // Creating new core value
          payload = {
            orgId: subKpa.orgId || this.$orgId,
            kpaTypeId: coreValues.id,
            objective: 'Custom Objective',
              name: subKpa.editedName,
              weight: 0,
          };
          response = await this.$_createKPAobjective(payload);
        }

        this.$toasted.success('Sub KPA saved successfully', { duration: 5000 });

        if (coreValues && coreValues.kpas) {
          const subIndex = coreValues.kpas.findIndex(k => k.id === subKpa.id);
          if (subIndex !== -1) {
            const updatedSubKpa = {
              ...subKpa,
              name: subKpa.editedName,
              isEditing: false,
              saved: true,
              isCustom: false
            };

            // If it was created (custom), update with the new ID from response
            if (subKpa.id && subKpa.id.toString().startsWith('custom-') && response?.data?.data?.id) {
              updatedSubKpa.id = response.data.data.id;
            }

            this.$set(coreValues.kpas, subIndex, updatedSubKpa);
          }
        }

        await this.getKPATypes();
      } catch (error) {
        this.$toasted.error(error.response?.data?.message || 'Error saving Sub KPA', { duration: 5000 });
      }
    },

    async saveToggleStatus() {
      try {
        const kpaTypes = [];
        this.kpaTypes.forEach(kpa => {
          // Skip custom KPAs that haven't been saved yet
          if (!kpa.id || kpa.id.toString().startsWith('custom-')) {
            return;
          }
          if (kpa.tempStatus !== (kpa.status === 'active')) {
            kpaTypes.push({
              id: kpa.id,
              status: kpa.tempStatus ? 'active' : 'inactive'
            });
          }
        });

        const coreValues = this.kpaTypes.find(k => k.kpas && k.kpas?.length > 0);
        let coreValuesChanged = false;
        let coreValuesPayload = null;
        if (coreValues?.kpas) {
          const changedSubKpas = coreValues.kpas
            .filter(subKpa => {
              // Skip custom sub-KPAs that haven't been saved yet
              if (!subKpa.id || subKpa.id.toString().startsWith('custom-')) {
                return false;
              }
              return subKpa.tempStatus !== (subKpa.status === 'active');
            })
            .map(subKpa => ({
              id: subKpa.id,
              status: subKpa.tempStatus ? 'active' : 'inactive'
            }));
          if (changedSubKpas?.length > 0) {
            coreValuesChanged = true;
            coreValuesPayload = {
              id: coreValues.id,
              status: coreValues.tempStatus ? 'active' : 'inactive',
              kpas: changedSubKpas
            };
          }
        }

        const payload = { orgId: this.$orgId };
        if (kpaTypes?.length && coreValuesChanged) {
          payload.kpaTypes = [
            ...kpaTypes,
            coreValuesPayload
          ];
        } else if (kpaTypes.length) {
          payload.kpaTypes = kpaTypes;
        } else if (coreValuesChanged) {
          payload.kpaTypes = [coreValuesPayload];
        } else {
          this.$toasted.info('No KPA status changes to save.', { duration: 3000 });
          return;
        }

        await this.$_toggleKPAtypes(payload);
        this.$toasted.success('KPA statuses updated successfully', { duration: 5000 });
        await this.getKPATypes();
        this.kpaModal = false;

      } catch (error) {
        this.$toasted.error(error.response?.data?.message || 'Error updating KPA statuses', { duration: 5000 });
      }
    },

    formatDateRange(startDate, endDate) {
      if (!startDate || !endDate) return '---';
      const start = new Date(startDate);
      const end = new Date(endDate);
      const getOrdinalSuffix = (day) => {
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
          case 1: return 'st';
          case 2: return 'nd';
          case 3: return 'rd';
          default: return 'th';
        }
      };
      const startDay = start.getDate();
      const endDay = end.getDate();
      const startMonth = start.toLocaleString('default', { month: 'long' });
      const endMonth = end.toLocaleString('default', { month: 'long' });
      const startOrdinal = getOrdinalSuffix(startDay);
      const endOrdinal = getOrdinalSuffix(endDay);
      if (startMonth === endMonth) {
        return `${startDay}${startOrdinal} to ${endDay}${endOrdinal} ${startMonth}`;
      }
      return `${startDay}${startOrdinal} ${startMonth} to ${endDay}${endOrdinal} ${endMonth}`;
    },

    truncateDescription(text) {
      if (!text) return '';
      return text.length > 16 ? `${text.substring(0, 15)}...` : text;
    },

    getLockIconName(template) {
      if (template && template?.isLocked) {
        return 'lock';
      }
        return 'unlock';
    },

    getAlphabetForLinkedTemplate(linkNo) {
      const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      if (typeof linkNo !== 'number' || linkNo < 1) return 'A';
      return letters[linkNo - 1] || 'A';
    },

    async createLinkedTemplate(template) {
      const templateId = template.id
      const templateLinkId = template.performance_templates[0].id
      try {
          await this.$handlePrivilege("performance", "editTemplateUsage");
          const fetchTemplate = this.$_getOneLinkTemplate(templateId)
          fetchTemplate.then((response) => {
            const {data} = response.data;
            if (data.isAppliedToAllEmp) {
              this.$toasted.error('Cannot create a linked template, this template is already assigned to all employees', { duration: 5000 });
            } else {
              this.$router.push({
          name: "LinkTemplateSettings",
          params: { id: templateId },
          query: { mode: 'link', templateLinkId }
        });
          }
        });
      } catch (error) {
        this.$toasted.error(error.response?.data?.message || 'Error preparing linked template', { duration: 5000 });
      }
    },
  },

  async mounted() {
    try {
      await this.$handlePrivilege(
        "performance",
        "accessPerformanceTemplateSettings"
      );
      await this.getKPATypes();
      await this.getTemplates(this.searchQuery);
      await this.getLocations();
      await this.getJobLevels();
      await this.getFunctions();
      await this.getDesignations();
    } catch (error) {
      this.errorPage = true;
    }
  },
};
</script>

<style>
.label label {
  display: none;
}
</style>

<style scoped>
.icon {
  width: 24px;
  height: 24px;
  padding: 3px;
}
.text-sm {
  font-size:13px !important;
}
.tempB_footer {
  height: 122px;
  padding: 8px;
}
.card-search {
  width: 320px;
  height: 40px;
}
.card-search input {
  width: 100%;
}

.switch {
  position: relative;
  display: inline-block;
  width: 24px;
  height: 12px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #EEEEEE;
  transition: 0.4s;
  border-radius: 20px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 9.6px;
  width: 9.6px;
  border-radius: 50%;
  left: 2px;
  bottom: 1.5px;
  background-color: #878E99;
  transition: 0.4s;
}

input:checked + .slider:before {
  transform: translateX(10px);
  background-color: #13B56A;
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

/* Checkbox styles for sub KPAs */
.checkbox-container {
  display: inline-block;
  position: relative;
  padding-left: 25px;
  cursor: pointer;
  user-select: none;
}

.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #EEEEEE;
  border-radius: 4px;
}

.checkbox-container:hover input ~ .checkmark {
  background-color: #ccc;
}

.checkbox-container input:checked ~ .checkmark {
  background-color: #F15A29;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-container .checkmark:after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
</style>
